import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../constants/common'
import { FieldStackedLabel } from '../../../../Field'
import {
  FlatMultiSelect,
  FlatSelectFormikField,
  getFlatSelectFormikFieldControlDisabledProps,
} from '../../../../Flat'
import {
  USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS,
  USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING,
  USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_SELECTED_FLATS,
} from '../../UserEditAddressFormModal.constants'

import {
  getFlatApiParams,
  toFlatWithBuildingSelectItems,
} from './FlatField.utils'

function FlatField({ disabled, isLoading }) {
  const { t } = useTranslation()
  const { setFieldValue, values } = useFormikContext()

  const buildingValue =
    values[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING]?.value

  const flatFieldApiParams = getFlatApiParams({
    building: buildingValue,
    flats: values[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS],
  })

  function handleCloseDropdown() {
    setFieldValue(USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS, [
      ...values[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS],
      ...values[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_SELECTED_FLATS],
    ])
    setFieldValue(
      USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_SELECTED_FLATS,
      EMPTY_LIST
    )
  }

  return (
    <FlatSelectFormikField
      multi
      Field={FieldStackedLabel}
      Select={FlatMultiSelect}
      Tags={null}
      apiParams={flatFieldApiParams}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder: t('User.FlatNumberPlaceholderKey'),
          },
        },
      }}
      disabled={disabled || !buildingValue}
      fieldComponentProps={{
        isLoading,
        label: `${t('User.FlatLabelKey')}:`,
      }}
      getFieldDisabledProps={getFlatSelectFormikFieldControlDisabledProps}
      name={USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_SELECTED_FLATS}
      toPreparedItems={toFlatWithBuildingSelectItems}
      onCloseDropdown={handleCloseDropdown}
    />
  )
}

export default FlatField
